import { WebApiCalls } from "../webApiCalls/webApiCalls";

const JustMerchants = async (merchantID) => {
  let returnData = {};
  await new WebApiCalls().getUserDetail(merchantID).then((response) => {
    if (response) {
      console.log("here is the response==========>", response);
      returnData["StoreName"] = response.DisplayName;
      response?.CustomFields?.length > 0 &&
        response.CustomFields?.map((item, index) => {
          if (item.Name == "Mall") {
            returnData = {
              ...returnData,
              ...{ MallName: item.Values[0] },
            };
          }
        });
    }
  });
  return returnData;
};
export default JustMerchants;
